<template>
  <div>
    <v-app-bar
      :elevation="0"
      height="72"
      class="user-select-none"
      :class="drawer ? '' : 'app-bar'"
    >
      <v-container class="d-flex">
        <!-- SPIL Logo -->
        <router-link
          to="/"
          @click="() => setActivePage('/')"
          class="text-decoration-none"
        >
          <img
            src="@/assets/spil_logo.svg"
            alt="SPIL Logo"
            width="70"
            height="45"
          />
        </router-link>

        <!-- Menu List -->
        <div class="w-100 d-none d-lg-flex justify-end align-center mr-5">
          <div v-for="(menu, idx) in navMenus" :key="idx" class="ml-12">
            <!-- Dropdown Menu -->
            <div
              v-if="containsKey(menu, 'items')"
              :id="menu.label"
              class="text-nav cursor-pointer d-flex align-center"
              :class="
                menu.key != 'lang' &&
                (menu.items
                  .map((item) => {
                    if (containsKey(item, 'href')) return item.href[currLang];
                  })
                  .includes(activePage) ||
                  activePage.includes(
                    this.$root.lang(menu.label).toLowerCase(),
                  ))
                  ? 'text-secondary'
                  : 'text-text-default nav-hover'
              "
              role="button"
              aria-hidden="true"
            >
              <img
                v-if="menu.key == 'lang'"
                :src="currLangImg"
                alt="Lang Flag"
                width="20"
                height="20"
                class="mr-2"
              />
              {{ lang(menu.label) }}
              <img
                src="@/assets/images/icons/arrow_down.svg"
                alt="dropdown icon"
                class="ml-2 arrow-icon"
                style="transition: 0.5s ease"
                :style="
                  menuOpen[idx] != null && menuOpen[idx] == true
                    ? 'transform: rotate(-180deg);'
                    : ''
                "
              />
            </div>

            <!-- Basic Menu -->
            <div v-else>
              <router-link
                :to="menu.href[currLang]"
                @click="setActivePage(menu.href[currLang])"
                class="text-decoration-none text-nav"
                :class="
                  activePage == menu.href[currLang]
                    ? 'text-secondary'
                    : 'text-text-default nav-hover'
                "
              >
                {{ lang(menu.label) }}
              </router-link>
            </div>
          </div>
        </div>

        <!-- MOBILE -->
        <div class="w-100 d-flex d-lg-none justify-end">
          <v-btn
            icon="mdi mdi-menu"
            :ripple="false"
            @click="drawer = !drawer"
            aria-label="drawer button"
          />
        </div>
      </v-container>
    </v-app-bar>

    <!-- MENU DROPDOWN LIST -->
    <div v-for="(menu, idx) in navMenus" :key="idx">
      <v-menu
        v-if="containsKey(menu, 'items')"
        :activator="'#' + menu.label"
        v-model="menuOpen[idx]"
        location="center"
        style="z-index: 1000"
      >
        <v-list class="mt-14 rounded-b-xl" elevation="0">
          <v-list-item
            v-for="(item, idx) in menu.items"
            :key="idx"
            :value="idx"
            class="pa-0"
          >
            <!-- Change Language -->
            <div
              v-if="containsKey(item, 'icon')"
              @click="toggleLanguage(item.value)"
              class="text-decoration-none text-nav text-text-default d-flex align-center nav-hover px-4"
              style="height: 40px"
            >
              <img
                :src="item.icon"
                alt="Lang Flag"
                width="20"
                height="20"
                class="mr-3"
              />
              {{ lang(item.label) }}
            </div>

            <!-- Regular Options -->
            <router-link
              v-else
              :to="item.href[currLang]"
              @click="setActivePage(item.href[currLang])"
              class="text-decoration-none text-nav d-flex align-center px-4"
              :class="
                activePage == item.href[currLang] ||
                activePage.includes(lang(item.label).toLowerCase())
                  ? 'text-secondary'
                  : 'text-text-default nav-hover'
              "
              style="height: 40px"
            >
              {{ lang(item.label) }}
            </router-link>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <!-- MENU DRAWER -->
    <client-only>
      <v-navigation-drawer
        v-model="drawer"
        location="top"
        class="d-block d-lg-none"
        color="#eee"
      >
        <v-container class="mt-6">
          <v-list-item
            v-for="(menu, idx) in navMenus"
            :key="idx"
            class="cursor-pointer text-text-default font-weight-medium pa-0"
          >
            <div>
              <!-- Dropdown Menu -->
              <div
                v-if="containsKey(menu, 'items')"
                @click="menuOpen[idx] = !menuOpen[idx]"
                :id="menu.label"
                class="text-nav cursor-pointer d-flex justify-space-between align-center"
                :class="
                  menu.items
                    .map((item) => {
                      if (containsKey(item, 'href')) return item.href[currLang];
                    })
                    .includes(activePage) ||
                  activePage.includes(menu.label.toLowerCase())
                    ? 'text-secondary'
                    : 'text-text-default nav-hover'
                "
                style="height: 40px"
              >
                <div class="d-flex align-center">
                  <img
                    v-if="menu.key == 'lang'"
                    :src="currLangImg"
                    alt="Lang Flag"
                    width="20"
                    height="20"
                    class="mr-2"
                  />
                  {{ lang(menu.label) }}
                </div>

                <img
                  src="@/assets/images/icons/arrow_down.svg"
                  alt="dropdown icon"
                  class="ml-2 arrow-icon"
                  style="transition: 0.5s ease"
                  :style="
                    menuOpen[idx] != null && menuOpen[idx] == true
                      ? 'transform: rotate(-180deg);'
                      : ''
                  "
                />
              </div>

              <!-- Basic Menu -->
              <router-link
                v-else
                :to="menu.href[currLang]"
                @click="setActivePage(menu.href[currLang])"
                class="text-decoration-none text-nav"
                :class="
                  activePage == menu.href[currLang]
                    ? 'text-secondary'
                    : 'text-text-default nav-hover'
                "
              >
                <div>{{ lang(menu.label) }}</div>
              </router-link>
            </div>

            <!-- Mobile Menu List -->
            <div v-show="menuOpen[idx]">
              <div
                v-for="(item, idx) in menu.items"
                :key="idx"
                class="d-flex align-center ml-4 my-2"
              >
                <!-- Change Language  -->
                <div
                  v-if="containsKey(item, 'icon')"
                  @click="toggleLanguage(item.value)"
                  class="text-decoration-none text-nav text-text-subdued d-flex align-center nav-hover w-100"
                >
                  <img
                    :src="item.icon"
                    alt="Lang Flag"
                    width="20"
                    height="20"
                    class="mr-3"
                  />
                  {{ lang(item.label) }}
                </div>

                <!-- Regular Options -->
                <router-link
                  v-else
                  :to="item.href[currLang]"
                  @click="setActivePage(item.href[currLang])"
                  class="text-decoration-none text-nav d-flex align-center w-100"
                  :class="
                    activePage == item.href[currLang] ||
                    activePage.includes(lang(item.label).toLowerCase())
                      ? 'text-secondary'
                      : 'text-text-subdued nav-hover'
                  "
                >
                  {{ lang(item.label) }}
                </router-link>
              </div>
            </div>
          </v-list-item>
        </v-container>
      </v-navigation-drawer>
    </client-only>
  </div>
</template>

<script>
import Indonesia from "@/assets/images/icons/indonesia.png";
import English from "@/assets/images/icons/united-kingdom.png";

import { mapActions, mapState } from "pinia";
import { useGeneralStore } from "@/stores/GeneralStore";

export default {
  name: "HeaderSPILPrime",
  data() {
    return {
      drawer: false,
      menuOpen: [],
      navMenus: [
        {
          key: "lang",
          label: "navLang",
          items: [
            {
              icon: Indonesia,
              label: "navID",
              value: "indonesia",
            },
            {
              icon: English,
              label: "navENG",
              value: "english",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["activePage"]),

    currLangImg() {
      return isIndonesia() ? Indonesia : English;
    },

    currLang() {
      return isIndonesia() ? "ind" : "eng";
    },
  },
  methods: {
    ...mapActions(useGeneralStore, ["toggleLanguage", "setActivePage"]),
  },
  mounted() {
    const pathname = window.location.pathname;
    this.setActivePage(pathname);
  },
};
</script>

<style scoped>
::v-deep .v-navigation-drawer--active {
  height: 100% !important;
}

.app-bar {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(8px);
}
.nav-hover:hover {
  text-shadow:
    0 0 1px #333,
    0 0 1px #333;
}
.arrow-icon {
  width: 12px;
  height: 12px;
  aspect-ratio: 1;
}
</style>
